<template lang="pug">
.ove-detail-view
  .loader(v-if="loading")
    b-spinner(variant="primary")

  template(v-else-if="oveDetail")
    .container-detail
      //- Header Navigation
      .header-ove.d-none.d-md-flex
        .title-section(@click="$router.push('/oportunidad-venta-equipo')")
          b-icon.back-arrow(icon="arrow-left-square-fill")
          h4.title Detalle OVE {{ oveDetail.id }}
        .actions-section
          OVSearchInput(
            v-model="paramsSearch"
            @search="buscar"
            desktop
          )

      .breadcrumbs-ove
        span.text-muted Inicio / Oportunidad de Venta de Equipos /
        span.text-dark {{ oveDetail.id }}

      //- Two-column content layout
      .content-layout
        //- Left panel
        .left-panel
          .main-card
            //- Top Header
            .card-top-header
              span.ove-id-label OVE {{ oveDetail.id }}

            //- Title, Status and Actions
            .title-actions-row
              .status-container
                h2.status-title Estado Actual
                StatusBadgeOVE(:status="oveDetail.estado")

              .actions-container
                b-button.btn-download-pdf(v-if="oveDetail.cotizacion_pdf" @click="downloadPDF" :disabled="recalculando")
                  b-icon(icon="file-earmark-arrow-down-fill")
                  span Descargar Cotización

                b-dropdown.btn-actions-ove(
                  v-if="tieneAcciones"
                  variant="primary" no-caret right
                  :disabled="loadingPDF || recalculando"
                )
                  template(#button-content="")
                    .d-flex.align-items-center
                      img.mr-2(src="@/assets/icons/actions.svg" alt="Acciones" style="width: 20px; height: 20px")
                      span Acciones
                  b-dropdown-item(v-if="oveDetail.estado === 'cotizacion_enviada'" @click="handleAction('Pagar Cotización')") Pagar Cotización
                  b-dropdown-item(v-if="oveDetail.estado === 'cotizacion_enviada'" @click="handleAction('Rechazar Cotización')") Rechazar Cotización
                  b-dropdown-item(v-if="oveDetail.estado === 'cotizacion_enviada'" @click="handleAction('Reenviar Cotización')" :disabled="loadingPDF")
                    b-spinner(small v-if="loadingPDF")
                    span(v-else) Reenviar Cotización
                  b-dropdown-item(v-if="oveDetail.estado === 'vencida'" @click="handleAction('Reactivar Cotización')") Reactivar Cotización
                  b-dropdown-item(v-if="availableActions.includes('Recalcular Totales')" @click="handleAction('Recalcular Totales')")
                    b-spinner(small v-if="recalculando")
                    span(v-else) Recalcular Totales

            //- Client Data Section
            .detail-section
              .section-subtitle
                b-icon(icon="person-fill")
                span Datos del Cliente

              .data-grid
                .data-item
                  label R.U.T
                  p.blue-text {{ oveDetail.rut }}
                .data-item
                  label Nombre
                  p {{ oveDetail.nombre }}
                .data-item
                  label Apellido
                  p {{ oveDetail.apellido }}
                .data-item
                  label Correo Electrónico
                  p {{ oveDetail.correo_cliente || oveDetail.correo_electronico }}

                .data-item
                  label Teléfono
                  p {{ oveDetail.telefono }}
                .data-item
                  label Región
                  p {{ oveDetail.region }}
                .data-item
                  label Comuna
                  p {{ oveDetail.comuna }}
                .data-item
                  label Dirección
                  p {{ oveDetail.direccion }}

                .data-item
                  label Persona de Contacto
                  p {{ oveDetail.persona_contacto || (oveDetail.nombre_cliente) }}

            //- Equipment Section
            .detail-section
              .section-subtitle
                b-icon(icon="tools")
                span Equipo Cotizado

              .equipment-grid
                .equipment-block(v-for="(item, index) in oveDetail.detalles" :key="index")
                  .serie-row
                    label N° De Serie Equipo
                    p.blue-text {{ item.equipo_numero_serie || 'SIN SERIE' }}

                  .product-card
                    .product-image
                      img(v-if="item.imagen_url" :src="formatImgUrl(item.imagen_url)")
                      b-icon(v-else icon="laptop" font-scale="2")
                    .product-info
                      p.product-name {{ item.equipo_nombre || item.modelo }}
                      p.product-price {{ (item.precio_unitario || 0) | formatCurrency }}

                  .item-details-row
                    .data-item
                      label Cantidad
                      p {{ item.cantidad || 1 }}
                    .data-item
                      label Descuento
                      p {{ item.porcentaje_descuento || 0 }}%

                  .warranty-row
                    label Tipo de Garantía
                    p {{ item.garantia_nombre || 'Sin garantía extendida' }} {{ item.precio_garantia > 0 ? '(' + formatCurrency(item.precio_garantia) + ')' : '' }}

        //- Right panel — Resumen
        .right-panel
          .resumen-card
            .detail-section
              .section-subtitle
                b-icon(icon="cash-stack")
                span Resumen

              .data-item.mb-3
                label Tipo de Despacho
                p {{ oveDetail.tipo_despacho === 'retiro' ? 'Retiro en Tienda' : 'Envío a Domicilio' }}

              .totals-summary-card
                .total-line
                  span.label Sub Total (neto)
                  span.value {{ formatCurrency(subtotal) }}
                .total-line
                  span.label Descuento (neto)
                  span.value - {{ formatCurrency(discountAmount) }}
                .total-line
                  span.label IVA (19%)
                  span.value {{ formatCurrency(iva) }}
                .total-line
                  span.label Embalaje y Envío (IVA incl.)
                  span.value {{ formatCurrency(shippingCost) }}

                hr.total-divider

                .total-line.final-total
                  span.label Total
                  span.value {{ formatCurrency(totalFinal) }}

  .not-found(v-else-if="!loading")
    .text-center.p-5
      h4 OVE no encontrada
      b-button(variant="primary" @click="$router.push('/oportunidad-venta-equipo')") Volver al listado

  StockValidationModal(
    ref="stockModal"
    :equipments="equipmentsSinStock"
    :oveId="oveDetail ? oveDetail.id : ''"
    :context="stockModalContext"
  )

  RejectOVEModal(
    ref="rejectModal"
    :ovedetail="oveDetail || {}"
    @rejected="onOveRejected"
  )
</template>

<script>
import { mapActions, mapState } from 'vuex'
import StatusBadgeOVE from '@/components/OVE/StatusBadgeOVE.vue'
import OVSearchInput from '@/components/OV/OVSearchInput.vue'
import StockValidationModal from '@/components/OVE/StockValidationModal.vue'
import RejectOVEModal from '@/components/OVE/RejectOVEModal.vue'
import { backUrl } from '../../../settings'

export default {
  name: 'OVEDetailView',
  components: {
    StatusBadgeOVE,
    OVSearchInput,
    StockValidationModal,
    RejectOVEModal,
  },
  data() {
    return {
      loading: true,
      loadingPDF: false,
      recalculando: false,
      paramsSearch: '',
      availableActions: [],
      equipmentsSinStock: [],
      stockModalContext: 'pagar',
    }
  },
  computed: {
    ...mapState('OVEStore', ['oveDetail']),

    // Desglose calculado en el backend (igual al PDF):
    // Sub Total (neto) − Descuento (neto) + IVA + Envío (IVA incl.) = Total
    resumen() {
      return this.oveDetail?.resumen || {}
    },

    subtotal() {
      return this.resumen.subtotal_neto || 0
    },

    iva() {
      return this.resumen.iva || 0
    },

    discountAmount() {
      return this.resumen.descuento_neto || 0
    },

    shippingCost() {
      return this.resumen.envio || 0
    },

    totalFinal() {
      if (!this.oveDetail) return 0
      return this.oveDetail.monto_total_final || 0
    },

    tieneAcciones() {
      if (!this.oveDetail) return false
      const { estado } = this.oveDetail
      return estado === 'cotizacion_enviada' || estado === 'vencida'
    },
  },
  methods: {
    ...mapActions('OVEStore', [
      'getOveDetail',
      'getOveActions',
      'verificarStock',
      'reactivarOve',
      'reenviarCotizacion',
      'recalcularOve',
    ]),

    async fetchData() {
      this.loading = true
      try {
        const id = this.$route.params.ove_id
        await this.getOveDetail(id)
        this.availableActions = await this.getOveActions(id)
      } catch (error) {
        console.error('Error fetching OVE detail:', error)
      } finally {
        this.loading = false
      }
    },

    downloadPDF() {
      if (this.oveDetail.cotizacion_pdf) {
        window.open(`${backUrl}${this.oveDetail.cotizacion_pdf}`, '_blank')
      }
    },

    async handleAction(action) {
      if (this.recalculando || this.loadingPDF) return
      console.log('Action triggered:', action)
      const { id } = this.oveDetail

      if (action === 'Pagar Cotización') {
        this.loading = true
        this.stockModalContext = 'pagar'
        try {
          const res = await this.verificarStock(id)
          if (res.hay_stock) {
            this.$router.push(`/oportunidad-venta-equipo/${id}/pagar`)
          } else {
            this.equipmentsSinStock = res.equipos_sin_stock
            this.$refs.stockModal.show()
          }
        } catch (error) {
          this.$bvToast.toast('Error al verificar stock', { variant: 'danger' })
        } finally {
          this.loading = false
        }
      } else if (action === 'Recalcular Totales') {
        this.recalculando = true
        try {
          await this.recalcularOve(id)
          this.$bvToast.toast(
            'Totales recalculados y cotización PDF actualizada',
            {
              variant: 'success',
            }
          )
        } catch (error) {
          this.$bvToast.toast(
            error.response?.data?.error || 'Error al recalcular la cotización',
            { variant: 'danger' }
          )
        } finally {
          this.recalculando = false
        }
      } else if (action === 'Reenviar Cotización') {
        this.loadingPDF = true
        try {
          await this.reenviarCotizacion(id)
          this.$bvToast.toast('Cotización reenviada al cliente exitosamente', {
            variant: 'success',
          })
        } catch (error) {
          this.$bvToast.toast('Error al reenviar la cotización', {
            variant: 'danger',
          })
        } finally {
          this.loadingPDF = false
        }
      } else if (action === 'Editar') {
        this.$router.push(`/oportunidad-venta-equipo/${id}/editar`)
      } else if (action === 'Rechazar Cotización') {
        this.$refs.rejectModal.show()
      } else if (action === 'Reactivar Cotización') {
        this.loading = true
        try {
          await this.reactivarOve({ ove_id: id })
          this.$toast.success(
            '¡Cotización reactivada con éxito!\nSu nueva vigencia es de 24 horas.',
            {
              timeout: 4000,
              hideProgressBar: true,
              closeButton: 'button',
              icon: true,
            }
          )
          await this.fetchData()
        } catch (error) {
          if (error.response && error.response.status === 409) {
            this.stockModalContext = 'reactivar'
            this.equipmentsSinStock =
              error.response.data.equipos_sin_stock || []
            this.$refs.stockModal.show()
          } else {
            this.$bvToast.toast('Error al reactivar la cotización', {
              variant: 'danger',
            })
          }
        } finally {
          this.loading = false
        }
      } else {
        this.$bvToast.toast(`Acción "${action}" no implementada todavía.`, {
          variant: 'info',
        })
      }
    },

    async onOveRejected() {
      await this.fetchData()
    },

    buscar() {
      // Búsqueda global desde detalle? Redirigir a lista con parámetro
      this.$router.push({
        path: '/oportunidad-venta-equipo',
        query: { search: this.paramsSearch },
      })
    },

    formatImgUrl(url) {
      if (!url) return null
      if (url.startsWith('http')) return url
      return `${backUrl}${url}`
    },

    formatCurrency(value) {
      if (value === undefined || value === null) return '$0'
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
      }).format(Math.floor(value))
    },
  },
  async mounted() {
    await this.fetchData()
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.ove-detail-view {
  background-color: #f5f6fa;
  min-height: 100vh;
  padding-bottom: 50px;
}

.container-detail {
  padding: 20px;
}

.header-ove {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 4rem;

  .title-section {
    display: flex;
    align-items: center;
    gap: 15px;
    cursor: pointer;

    .back-arrow {
      color: $samtek-yellow;
      font-size: 32px;
    }

    .title {
      margin: 0;
      font-weight: bold;
      color: $samtek-black;
    }
  }
}

.breadcrumbs-ove {
  margin-bottom: 25px;
  font-size: 14px;
}

.content-layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.left-panel {
  flex: 1;
  min-width: 0;
}

.right-panel {
  width: 386px;
  flex-shrink: 0;
}

.main-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
}

.resumen-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
}

.card-top-header {
  margin-bottom: 16px;

  .ove-id-label {
    font-family: 'Noto Sans', sans-serif;
    font-weight: 700;
    font-size: 15px;
    color: #525252;
  }
}

.title-actions-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;

  .status-container {
    display: flex;
    align-items: center;
    gap: 20px;

    .status-title {
      font-family: 'Noto Sans', sans-serif;
      font-weight: 700;
      font-size: 25px;
      color: #23201c;
      margin: 0;
    }
  }

  .actions-container {
    display: flex;
    gap: 10px;

    .btn-download-pdf {
      background-color: #f5f6fa;
      border: 1px solid $samtek-yellow;
      color: $samtek-black;
      border-radius: 8px;
      height: 40px;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0 15px;
      font-weight: 500;
      font-size: 15px;

      &:hover {
        background-color: darken(#f5f6fa, 2%);
      }
    }

    .btn-actions-ove {
      ::v-deep .btn {
        background-color: $samtek-yellow;
        border: none;
        color: $samtek-black;
        border-radius: 8px;
        height: 40px;
        font-weight: 500;
        font-size: 15px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        gap: 8px;
        width: 130px;

        &:hover {
          background-color: darken($samtek-yellow, 5%);
        }
      }
    }
  }
}

.detail-section {
  margin-bottom: 32px;

  .section-subtitle {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;

    .b-icon {
      font-size: 24px;
      color: #23201c;
    }

    span {
      font-family: 'Noto Sans', sans-serif;
      font-weight: 700;
      font-size: 20px;
      color: #23201c;
    }
  }
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.data-item {
  label {
    display: block;
    font-family: 'Noto Sans', sans-serif;
    font-weight: 700;
    font-size: 15px;
    color: #525252;
    margin-bottom: 2px;
  }

  p {
    font-family: 'Noto Sans', sans-serif;
    font-size: 15px;
    color: #525252;
    margin: 0;

    &.blue-text {
      color: #1d4ed8;
      font-weight: 700;
    }
  }
}

.equipment-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.equipment-block {
  .serie-row {
    margin-bottom: 12px;
  }

  .product-card {
    background: #ffffff;
    border: 1px solid #444444;
    border-radius: 4px;
    padding: 15px;
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 15px;

    .product-image {
      width: 68px;
      height: 68px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }

    .product-info {
      .product-name {
        font-family: 'Noto Sans', sans-serif;
        font-size: 15px;
        color: #525252;
        margin-bottom: 5px;
      }

      .product-price {
        font-family: 'Noto Sans', sans-serif;
        font-weight: 700;
        font-size: 15px;
        color: #1d4ed8;
        margin: 0;
      }
    }
  }

  .item-details-row {
    display: flex;
    gap: 40px;
    margin-bottom: 15px;
  }

  .warranty-row {
    margin-bottom: 10px;
  }
}

.totals-summary-card {
  background: rgba(244, 194, 53, 0.1);
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .total-line {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .label {
      font-family: 'Noto Sans', sans-serif;
      font-weight: 700;
      font-size: 18px;
      color: #525252;
    }

    .value {
      font-family: 'Noto Sans', sans-serif;
      font-size: 15px;
      color: #525252;
    }

    &.final-total {
      .label {
        font-size: 20px;
        color: #23201c;
      }
      .value {
        font-size: 20px;
        font-weight: 700;
        color: #23201c;
      }
    }
  }

  .total-divider {
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    margin: 10px 0;
  }
}

@media (max-width: 1200px) {
  .content-layout {
    flex-direction: column;
  }

  .right-panel {
    width: 100%;
  }

  .data-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .title-actions-row {
    flex-direction: column;
    gap: 20px;
  }

  .data-grid {
    grid-template-columns: 1fr;
  }

  .equipment-grid {
    grid-template-columns: 1fr;
  }
}
</style>
